import { MouseEvent, ReactElement, ReactNode } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { LoadingButtonProps } from '@mui/lab'
import DeleteButton from '../DeleteButton'

interface Props extends LoadingButtonProps {
  children: ReactNode
  hotkey?: string
  hotkeyInfo?: string
  showHotkeyInfo?: boolean
}

const HotkeyDeleteButton = ({
  children,
  hotkey = 'delete',
  hotkeyInfo = 'Entf',
  showHotkeyInfo = true,
  onClick,
  disabled,
  loading,
  ...props
}: Props): ReactElement => {
  useHotkeys(
    hotkey,
    event => {
      onClick?.(event as unknown as MouseEvent<HTMLButtonElement>)
    },
    {
      enabled: Boolean(hotkey) && !disabled && !loading,
      preventDefault: true,
    },
    [onClick, disabled, loading, hotkey],
  )

  return (
    <DeleteButton onClick={onClick} disabled={disabled} loading={loading} {...props}>
      {children}
      {showHotkeyInfo && hotkeyInfo ? ` [${hotkeyInfo}]` : null}
    </DeleteButton>
  )
}

export default HotkeyDeleteButton
